// Observes RTCPeerConnections for the in-call status pill - must run before the app creates any.
import "./lobby/incall";

import "./theme/scss/bootstrap.scss";

import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";
import { App } from "./app/App";

// Imported after the app so they override the component styles.
import "./lobby/theme.css";
import "./lobby/lobby.css";
import { runLobby } from "./lobby/lobby";

// The pre-join lobby runs first; the app (signaling + WebRTC) starts only after the user joins.
runLobby().then(() => {
  ReactDOM.render(<App />, document.getElementById("root"));
});

serviceWorker.unregister();
